// Dispatch dates in the page (issue 29). When the pincode gate announces the customer's menu
// (`cck:region`), this works out the dispatch and arrival dates with cck-dispatch-core.js and:
// - fills every [data-cck-dispatch] element: its [data-cck-dispatch-day] child gets "Mon 12 Oct",
//   its [data-cck-dispatch-arrival] child the arrival text (the homepage, product page and cart
//   use these; issues 30, 32, 33);
// - saves the date on the cart as the "Dispatch date" attribute, so it's on the order.
import { dispatchFor, dispatchText, withCalendar } from "@cck/dispatch-core";

const el = document.getElementById("cck-region-data");
/**
 * dispatchUrl: the rules built from catalog/dispatch.yaml; calendar: the store's festival
 * calendar (shop metafield cck.dispatch_calendar, edited in CCK Ops, issue 40), which wins.
 * @type {{ dispatchUrl?: string, calendar?: unknown }}
 */
let data = {};
try {
  data = JSON.parse(el?.textContent ?? "{}");
} catch {
  data = {};
}

/** @type {Promise<import("./cck-dispatch-core.js").Rules> | null} */
let rulesPromise = null;
const rules = () =>
  (rulesPromise ??= fetch(data.dispatchUrl ?? "").then((r) => {
    if (!r.ok) throw new Error(`dispatch rules: HTTP ${r.status}`);
    return r.json().then((rules) => withCalendar(rules, data.calendar));
  }));

/** The dispatch for this customer right now, or null before they have a menu. */
export async function currentDispatch(/** @type {"ncr" | "national" | null} */ region) {
  if (region !== "ncr" && region !== "national") return null;
  return dispatchFor(region, new Date(), await rules());
}

async function show(/** @type {"ncr" | "national" | null} */ region) {
  const x = await currentDispatch(region);
  for (const box of document.querySelectorAll("[data-cck-dispatch]")) {
    if (!(box instanceof HTMLElement)) continue;
    box.hidden = !x;
    if (!x) continue;
    const t = dispatchText(x);
    const day = box.querySelector("[data-cck-dispatch-day]");
    const arrival = box.querySelector("[data-cck-dispatch-arrival]");
    if (day) day.textContent = t.dispatch;
    if (arrival) arrival.textContent = t.arrival;
    box.dataset.dispatchDate = x.dispatch;
  }
  if (!x) return;
  document.dispatchEvent(new CustomEvent("cck:dispatch", { detail: x }));
  const value = `${dispatchText(x).dispatch} (${x.dispatch})`;
  // Only write the attribute when it changes, not on every page view.
  try {
    if (sessionStorage.getItem("cck:dispatch-attr") === value) return;
  } catch {
    // Storage blocked: write it anyway.
  }
  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ attributes: { "Dispatch date": value } }),
  });
  try {
    sessionStorage.setItem("cck:dispatch-attr", value);
  } catch {
    // ignore
  }
}

document.addEventListener("cck:region", (e) => {
  const { region } = /** @type {CustomEvent} */ (e).detail ?? {};
  show(region ?? null).catch((err) => console.warn("[cck-dispatch]", err));
});
